import { ImportButton } from "react-admin-import-csv";
import { CreateButton, TopToolbar } from "react-admin";

const ListActions = (props) => {
  const { className, basePath } = props;
  const config = {
    logging: true,
    validateRow: async (row) => {
    },
    postCommitCallback: locations => {
      // console.log('locations', {locations});
    },
  };
  return (
    <TopToolbar className={className}>
      <CreateButton basePath={basePath} />
      <ImportButton {...props} { ...config} />
    </TopToolbar>
  );
};

export default ListActions;